export default __webpack_public_path__ + "static/media/a011-startup-03.e700f3a2.svg";